import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, Input, ViewChild, HostListener, Component, ViewEncapsulation, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { DotKeyMapService } from '@ng-dot/ui';
import * as i1 from '@ng-dot/ui/ci24';
import { DotCi24Module } from '@ng-dot/ui/ci24';
import { DotContextService } from '@ng-dot/ux/context';
import * as i4 from '@ng-dot/ui/icon';
import { DotIconModule } from '@ng-dot/ui/icon';
import * as i3 from '@ng-dot/ui/link';
import { DotLinkModule } from '@ng-dot/ui/link';
import * as i2 from '@ng-dot/ui/trans';
import { DotTransDirective } from '@ng-dot/ui/trans';
import { DotUpDirective } from '@ng-dot/ux/up';
import { BehaviorSubject } from 'rxjs';
import { setOverlayPosition } from '@js-dot/ux';
const _c0 = ["toggleRef"];
const _c1 = ["areaRef"];
const _c2 = ["*"];
function DotMoreLinksComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
    i0.ɵɵpipe(1, "icon");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.icon, ctx_r1.label), i0.ɵɵsanitizeHtml);
  }
}
function DotMoreLinksComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2)(1, "dot-ci24", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.label, i0.ɵɵsanitizeHtml);
  }
}
class DotMoreLinksComponentBase {
  icon;
  label;
  up = 2;
  toggleRef;
  areaRef;
  isExpand;
  toggleTip;
  tip$ = new BehaviorSubject(null);
  _root;
  _body;
  _node;
  _classList;
  _escListener;
  _selfToggle = this.toggle.bind(this);
  _context;
  _keyMap;
  constructor() {
    this._context = inject(DotContextService);
    this._keyMap = inject(DotKeyMapService);
    const ngDocument = inject(DOCUMENT);
    const elementRef = inject(ElementRef);
    this._node = elementRef.nativeElement;
    this._classList = elementRef.nativeElement.classList;
    this._root = ngDocument.documentElement;
    this._body = ngDocument.body;
  }
  ngAfterContentInit() {
    const values = [];
    const buttons = this.areaRef.nativeElement.querySelectorAll('button:not(:disabled)');
    let current = buttons.length;
    while (current-- > 0) {
      values[current] = buttons[current].textContent;
    }
    const items = values.join('\n').replace(/^\t*\s*(.*)\s*$/gm, '$1').trim().split('\n');
    this.tip$.next(items.length > 3 ? items.slice(0, 3).join(', ') + '...' : items.join(', '));
  }
  _setPosition() {
    setOverlayPosition(this._root, this._node, this.areaRef.nativeElement);
  }
  onWindowResize() {
    if (this.isExpand) {
      this._setPosition();
    }
  }
  onWindowScroll() {
    if (this.isExpand) {
      this._setPosition();
    }
  }
  toggle() {
    if (this.isExpand) {
      this._context.hide(this);
    } else {
      this._context.show(this);
    }
  }
  hide() {
    this.isExpand = false;
    const area = this.areaRef.nativeElement;
    area.classList.remove('_show');
    this._node.appendChild(area);
    this._escListener.remove();
    this._node.firstElementChild.focus({
      preventScroll: true
    });
  }
  show() {
    this.isExpand = true;
    const area = this.areaRef.nativeElement;
    area.classList.add('_show');
    this._body.appendChild(area);
    this._setPosition();
    this._escListener = this._keyMap.once('esc', this._selfToggle);
    const {
      firstElementChild
    } = area;
    if (firstElementChild) {
      firstElementChild.focus({
        preventScroll: true
      });
    }
  }
  static ɵfac = function DotMoreLinksComponentBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotMoreLinksComponentBase)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotMoreLinksComponentBase,
    viewQuery: function DotMoreLinksComponentBase_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
        i0.ɵɵviewQuery(_c1, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleRef = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.areaRef = _t.first);
      }
    },
    hostBindings: function DotMoreLinksComponentBase_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("resize", function DotMoreLinksComponentBase_resize_HostBindingHandler() {
          return ctx.onWindowResize();
        }, false, i0.ɵɵresolveWindow)("scroll", function DotMoreLinksComponentBase_scroll_HostBindingHandler() {
          return ctx.onWindowScroll();
        }, false, i0.ɵɵresolveWindow);
      }
    },
    inputs: {
      icon: "icon",
      label: "label",
      up: "up"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotMoreLinksComponentBase, [{
    type: Directive
  }], () => [], {
    icon: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    up: [{
      type: Input
    }],
    toggleRef: [{
      type: ViewChild,
      args: ['toggleRef', {
        static: true
      }]
    }],
    areaRef: [{
      type: ViewChild,
      args: ['areaRef', {
        static: true
      }]
    }],
    onWindowResize: [{
      type: HostListener,
      args: ['window:resize']
    }],
    onWindowScroll: [{
      type: HostListener,
      args: ['window:scroll']
    }]
  });
})();
class DotMoreLinksComponent extends DotMoreLinksComponentBase {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotMoreLinksComponent_BaseFactory;
    return function DotMoreLinksComponent_Factory(__ngFactoryType__) {
      return (ɵDotMoreLinksComponent_BaseFactory || (ɵDotMoreLinksComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotMoreLinksComponent)))(__ngFactoryType__ || DotMoreLinksComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotMoreLinksComponent,
    selectors: [["dot-more-links"]],
    hostAttrs: ["data-context", "", 1, "dot-more-links"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c2,
    decls: 6,
    vars: 2,
    consts: [["areaRef", ""], ["dot-link", "", 1, "dot-more-links-toggle", 3, "click"], [3, "innerHTML"], ["dotTrans", "o", 1, "dot-more-links-area", 3, "dotUp"], ["type", "dots_vertical"]],
    template: function DotMoreLinksComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 1);
        i0.ɵɵlistener("click", function DotMoreLinksComponent_Template_button_click_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.toggle());
        });
        i0.ɵɵtemplate(1, DotMoreLinksComponent_Conditional_1_Template, 2, 4, "span", 2)(2, DotMoreLinksComponent_Conditional_2_Template, 2, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3, 0);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.icon ? 1 : 2);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dotUp", ctx.up);
      }
    },
    dependencies: () => [i1.DotCi24Component, DotUpDirective, i2.TransDirective, i3.DotLinkComponent, i4.DotIconPipe],
    styles: [":root{--more-links-back: #fff;--more-links-text: #000;--more-links-min-width: 120px}@media (prefers-color-scheme: dark){:root{--more-links-back: #000;--more-links-text: #fff}}.dot-more-links .dot-more-links-area,.dot-to-more-links._more .dot-more-links-area,.dot-more-links-area._show,.dot-to-more-links-area._show{display:none;position:fixed;z-index:10000;flex-direction:column;left:0;background-color:var(--more-links-back);color:var(--more-links-text);padding:10px;min-width:var(--more-links-min-width)}.dot-more-links .dot-more-links-area a,.dot-to-more-links._more .dot-more-links-area a,.dot-more-links-area._show a,.dot-to-more-links-area._show a,.dot-more-links .dot-more-links-area button,.dot-to-more-links._more .dot-more-links-area button,.dot-more-links-area._show button,.dot-to-more-links-area._show button{display:block;min-width:100%;min-height:48px;text-align:left;white-space:nowrap;margin:0!important}.dot-more-links .dot-more-links-area hr,.dot-to-more-links._more .dot-more-links-area hr,.dot-more-links-area._show hr,.dot-to-more-links-area._show hr{display:block;border:1px solid currentColor;margin-left:10px;margin-right:10px}.dot-more-links .dot-more-links-area .icon-label,.dot-to-more-links._more .dot-more-links-area .icon-label,.dot-more-links-area._show .icon-label,.dot-to-more-links-area._show .icon-label{display:inline!important}.dot-more-links,.dot-to-more-links{position:relative}.dot-more-links-area,.dot-to-more-links-area{box-shadow:none}.dot-more-links-area hr,.dot-to-more-links-area hr{display:none}.dot-more-links-area._show,.dot-to-more-links-area._show{position:fixed;display:flex}.dot-more-links+.dot-more-links:not(:first-child),.dot-more-links+.dot-link:not(:first-child),.dot-more-links+.dot-to-more-links:not(:first-child),.dot-to-more-links+.dot-link:not(:first-child),.dot-to-more-links+.dot-more-links:not(:first-child),.dot-to-more-links+.dot-to-more-links:not(:first-child){margin-left:var(--link-gap)}.dot-more-links .dot-more-links-toggle,.dot-to-more-links._more .dot-more-links-toggle{display:inline-flex;align-items:center;visibility:visible}.dot-more-links .dot-more-links:not(._js) .dot-more-links .dot-more-links-toggle:focus~.dot-more-links-area,.dot-more-links .dot-more-links:not(._js) .dot-to-more-links._more .dot-more-links-toggle:focus~.dot-more-links-area,.dot-to-more-links._more .dot-more-links:not(._js) .dot-more-links .dot-more-links-toggle:focus~.dot-more-links-area,.dot-to-more-links._more .dot-more-links:not(._js) .dot-to-more-links._more .dot-more-links-toggle:focus~.dot-more-links-area{display:flex}.dot-to-more-links .dot-more-links-area{box-shadow:none}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotMoreLinksComponent, [{
    type: Component,
    args: [{
      selector: 'dot-more-links',
      template: `
		<button dot-link class="dot-more-links-toggle" (click)="toggle()">
		  @if (icon) {
		    <span [innerHTML]="icon | icon: label"></span>
		  } @else {
		    <span [innerHTML]="label"></span>
		    <dot-ci24 type="dots_vertical"></dot-ci24>
		  }
		</button>
		<div class="dot-more-links-area" [dotUp]="up" dotTrans="o" #areaRef>
		  <ng-content></ng-content>
		</div>
		`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-more-links',
        'data-context': ''
      },
      standalone: false,
      styles: [":root{--more-links-back: #fff;--more-links-text: #000;--more-links-min-width: 120px}@media (prefers-color-scheme: dark){:root{--more-links-back: #000;--more-links-text: #fff}}.dot-more-links .dot-more-links-area,.dot-to-more-links._more .dot-more-links-area,.dot-more-links-area._show,.dot-to-more-links-area._show{display:none;position:fixed;z-index:10000;flex-direction:column;left:0;background-color:var(--more-links-back);color:var(--more-links-text);padding:10px;min-width:var(--more-links-min-width)}.dot-more-links .dot-more-links-area a,.dot-to-more-links._more .dot-more-links-area a,.dot-more-links-area._show a,.dot-to-more-links-area._show a,.dot-more-links .dot-more-links-area button,.dot-to-more-links._more .dot-more-links-area button,.dot-more-links-area._show button,.dot-to-more-links-area._show button{display:block;min-width:100%;min-height:48px;text-align:left;white-space:nowrap;margin:0!important}.dot-more-links .dot-more-links-area hr,.dot-to-more-links._more .dot-more-links-area hr,.dot-more-links-area._show hr,.dot-to-more-links-area._show hr{display:block;border:1px solid currentColor;margin-left:10px;margin-right:10px}.dot-more-links .dot-more-links-area .icon-label,.dot-to-more-links._more .dot-more-links-area .icon-label,.dot-more-links-area._show .icon-label,.dot-to-more-links-area._show .icon-label{display:inline!important}.dot-more-links,.dot-to-more-links{position:relative}.dot-more-links-area,.dot-to-more-links-area{box-shadow:none}.dot-more-links-area hr,.dot-to-more-links-area hr{display:none}.dot-more-links-area._show,.dot-to-more-links-area._show{position:fixed;display:flex}.dot-more-links+.dot-more-links:not(:first-child),.dot-more-links+.dot-link:not(:first-child),.dot-more-links+.dot-to-more-links:not(:first-child),.dot-to-more-links+.dot-link:not(:first-child),.dot-to-more-links+.dot-more-links:not(:first-child),.dot-to-more-links+.dot-to-more-links:not(:first-child){margin-left:var(--link-gap)}.dot-more-links .dot-more-links-toggle,.dot-to-more-links._more .dot-more-links-toggle{display:inline-flex;align-items:center;visibility:visible}.dot-more-links .dot-more-links:not(._js) .dot-more-links .dot-more-links-toggle:focus~.dot-more-links-area,.dot-more-links .dot-more-links:not(._js) .dot-to-more-links._more .dot-more-links-toggle:focus~.dot-more-links-area,.dot-to-more-links._more .dot-more-links:not(._js) .dot-more-links .dot-more-links-toggle:focus~.dot-more-links-area,.dot-to-more-links._more .dot-more-links:not(._js) .dot-to-more-links._more .dot-more-links-toggle:focus~.dot-more-links-area{display:flex}.dot-to-more-links .dot-more-links-area{box-shadow:none}\n"]
    }]
  }], null, null);
})();
class DotMoreLinksModule {
  static ɵfac = function DotMoreLinksModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotMoreLinksModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotMoreLinksModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, DotCi24Module, DotIconModule, DotTransDirective, DotLinkModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotMoreLinksModule, [{
    type: NgModule,
    args: [{
      declarations: [DotMoreLinksComponent],
      imports: [CommonModule, DotCi24Module, DotIconModule, DotUpDirective, DotTransDirective, DotLinkModule],
      exports: [DotMoreLinksComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotMoreLinksComponent, DotMoreLinksComponentBase, DotMoreLinksModule };
